import React from "react"
import styled from "styled-components"
import Container from "./forLayout/container"
import { useStaticQuery, graphql } from "gatsby"

const SectionTitle = styled.h2`
  font-family: "GFS Didot", serif;
  font-size: 4rem;
  line-height: 4rem;
  margin-bottom: 2rem;
`

const Spacer = styled.div`
  padding: 1.5rem 0;
`

const SectionParagraph = styled.p`
  font-family: "GFS Didot", serif;
  font-size: 1.4rem;
  line-height: 2.5rem;
  margin: 0;
  color: #dedede;
  max-width: 650px;
  a {
    text-decoration: underline;
    color: #fff;
  }
  a:hover {
    color: #fff;
  }
`
const Row = styled.div`
  display: flex;
  flex-direction: column;
  > div {
    margin-top: 2rem;
  }

  @media screen and (min-width: 768px) {
    flex-direction: row;
  }
`

const Gallery = styled.div`
  flex: 0 0 100%;
  max-width: 100%;
  p {
    color: #999;
  }

  @media screen and (min-width: 768px) {
    flex: 0 0 33.333333%;
    max-width: 33.333333%;
    padding-right: 0.5rem;
    > :last-child {
      padding-right: 0;
    }
  }
`
const GalleryImage = styled.img`
  object-fit: cover;
  width: 100%;
`

const SixthSection = () => {
  const SixthSectionData = useStaticQuery(graphql`
    {
      justdoitImage: allPixabayPhoto(limit: 3) {
        edges {
          node {
            largeImageURL
            user
          }
        }
      }
    }
  `)
  let miniGallery = []
  SixthSectionData.justdoitImage.edges.map((image, index) => {
    miniGallery.push(
      <Gallery>
        <GalleryImage
          src={image.node.largeImageURL}
          alt={`photo by ${image.node.user}`}
        />
        <p>@{image.node.user}</p>
      </Gallery>
    )
  })
  return (
    <Container>
      <SectionTitle>#justdoit</SectionTitle>
      <Spacer />
      <SectionParagraph>
        Tag a photo of you living your crazy dream with #justdoit and we may
        feature it below.
      </SectionParagraph>
      <Spacer />
      <Row>{miniGallery}</Row>
    </Container>
  )
}

export default SixthSection
